import day from "dayjs";
import isEmpty from "lodash/isEmpty";

import { Button, Tag, Tooltip } from "antd";
import { CalendarOutlined } from "@ant-design/icons";

const formatDateTime = (unixSeconds) => {
  if (!unixSeconds) return "";
  return day.unix(unixSeconds).format("MMM D, YYYY h:mm A");
};

export const CalendarEventPreview = ({ event }) => {
  if (!event) return null;

  const { attendees, end, location, organizer, subject, webLink } = event;

  const containerStyle = {
    background: "rgba(0, 0, 0, 0.02)",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    borderRadius: "8px",
    marginBottom: "8px",
    padding: "12px",
  };

  return (
    <div style={containerStyle}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            alignItems: "center",
            display: "flex",
            marginBottom: "8px",
          }}
        >
          <Tag>
            <Tooltip title="Calendar">
              <CalendarOutlined style={{ marginRight: "8px" }} />
            </Tooltip>
            {formatDateTime(end)}
          </Tag>
          <Button
            ghost
            onClick={() => {
              if (webLink)
                window.open(webLink, "_blank", "noopener,noreferrer");
            }}
            type="primary"
            style={{ marginLeft: "auto" }}
            disabled={!webLink}
          >
            Open event
          </Button>
        </div>
        <div>
          <strong>Subject</strong> {subject}
        </div>
        {!isEmpty(organizer) && (
          <div>
            <strong>Organizer</strong> {organizer.join(", ")}
          </div>
        )}
        {!isEmpty(attendees) && (
          <div>
            <strong>Attendees</strong> {attendees.join(", ")}
          </div>
        )}
        {!isEmpty(location) && (
          <div>
            <strong>Location</strong> {location}
          </div>
        )}
      </div>
    </div>
  );
};
